import { ApiFactory, type ApiDataResponse } from '@/utils/api';
import type { Theme, TodayMessageReq, TodayMessageRes } from '@/models/interface/today';

export class TodayService extends ApiFactory {
  constructor() {
    super('TodayMessage');
  }

  getTodayMessage(param: TodayMessageReq): Promise<ApiDataResponse<TodayMessageRes>> {
    return super.post('', param, {
      headers: {
        disableGlobalLoading: true
      }
    });
  }

  getTheme(): Promise<ApiDataResponse<Theme>> {
    return super.get('GetTheme');
  }
}
